import { render, staticRenderFns } from "./HwTypeTop5.vue?vue&type=template&id=6a0f0f18&"
import script from "./HwTypeTop5.vue?vue&type=script&lang=js&"
export * from "./HwTypeTop5.vue?vue&type=script&lang=js&"
import style0 from "./HwTypeTop5.vue?vue&type=style&index=0&id=6a0f0f18&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports